import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import { Icon } from '@fuxi/eevee-icon';
import service from '@/service';
import { useNav } from '@/hooks';
import { ALL_PAGES } from '@/constant';
import TreatmentCourseRecommend from './TreatmentCourseRecommend';
import DetectionResult from './DetectionResult';
import cx from './index.module.scss';

interface Props {
  type: 'no-hopeType' | 'has-hopeType';
  expand: boolean;
  customerId: number;
  isHasMorePlan?: boolean;
}

const ExpandContent: React.FC<Props> = ({ type, expand, customerId, isHasMorePlan }) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const nav = useNav();
  // 获取最新用户信息
  const [customerInfo, setCustomerInfo] = useState<GetCustomerProfileResponse>(null);

  const getServiceCustomerInfo = async customerId => {
    try {
      setIsLoading(true);
      const { data } = await service.customer.getCustomerProfile(customerId);

      setCustomerInfo(data);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (expand) {
      getServiceCustomerInfo(customerId);
    }
  }, [customerId, expand]);

  return (
    <div className={cx('content-wrapper', { show: expand })}>
      {expand &&
        (type === 'no-hopeType' ? (
          <div className={cx('skeleton-box')}>
            <Skeleton loading={isLoading} title={false} paragraph={{ rows: 2 }}>
              <div className={cx('member-info')}>
                <div
                  className={cx('member-info-box', {
                    show: !!customerInfo?.physicalAssessment?.length,
                  })}
                >
                  <div>身体情况</div>
                  <div>{customerInfo?.physicalAssessment?.join('、')}</div>
                </div>
                <div
                  className={cx('member-info-box', {
                    show: !!customerInfo?.adjustmentPurpose?.length,
                  })}
                >
                  <div>理疗诉求</div>
                  <div>{customerInfo?.adjustmentPurpose?.join('、')}</div>
                </div>
              </div>
            </Skeleton>
          </div>
        ) : (
          <div className={cx('has-hopeType')}>
            <div className={cx('wrapper')}>
              <DetectionResult loading={isLoading} customerInfo={customerInfo} />

              <div className={cx('add-service', { show: isHasMorePlan })} onClick={() => nav(ALL_PAGES.ADD_SERVICE)}>
                <div className={cx('add-service-text')}>
                  <Icon name="add-service" className={cx('icon')} />
                  <span>新建服务，开始理疗</span>
                </div>
              </div>
            </div>

            <TreatmentCourseRecommend loading={isLoading} customerInfo={customerInfo} />
          </div>
        ))}
    </div>
  );
};

export default ExpandContent;
